export enum ActionTypes {
  GetMarketingCampaignsFeatures = 'getMarketingCampaignsFeatures',
  GetMarketingCampaignsFeaturesSuccess = 'getMarketingCampaignsFeatures.success',
  GetMarketingCampaignsFeaturesFailure = 'getMarketingCampaignsFeatures.failure',
}
